import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Message } from 'src/app/model/message';
import { environment } from 'src/environments/environment';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { Router } from '@angular/router';
import { IndustryModuleCode, IndustryProductID } from 'src/app/model/industry';
import { MagoWebService } from './mago-web.service';

@Injectable({ providedIn: 'root' })
export class NavigateService {
    constructor(private workFlow: WorkFlowService, private router: Router, private magoWebService: MagoWebService) {}

    public navigateHelp() {
        if (this.workFlow.languageIsItalian()) {
            return window.open(environment.settings.helpMagoCloudStore + 'ITA/', '_blank');
        } else {
            return window.open(environment.settings.helpMagoCloudStore + 'ENG/', '_blank');
        }
    }

    public goToMagoCloudMKT() {
        return window.open('https://mago.cloud', '_blank');
    }

    public goToMyMagoCloud() {
        window.open('https://my.mago.cloud', '_blank');
    }

    public goToHomePage() {
        this.router.navigate(['/home']);
        return;
    }

    public goToDashboard() {
        this.router.navigate(['/mydashboard']);
    }

    public goToManagement() {
        this.router.navigate(['subscription-account']);
    }

    public goToMyProfileGlobal() {
        this.router.navigate(['/my-profile-global']);
    }

    public goToHelpCenter() {
        this.router.navigate(['/contacts-global']);
    }

    public goToUsoInterno() {
        this.router.navigate(['/internal-use-global']);
    }

    public goToDocumentation() {
        this.router.navigate(['/documentation']);
    }

    public goToRankingPage() {
        this.router.navigate(['/ranking-management']);
    }

    public goToMyUsers() {
        this.router.navigate(['/my-users/my-users']);
    }

    public goToProducts() {
        this.router.navigate(['/products-download/products-download']);
    }

    public goToTechnicalSupport() {
        this.router.navigate(['/technical-support/technical-support']);
    }

    public goToImprovementRequest() {
        this.router.navigate(['/technical-support/improvement-request']);
    }

    public goToMyCustomers() {
        this.router.navigate(['/my-customers/my-customers']);
    }

    public goToMagoUniversity() {
        this.router.navigate(['/mago-university/mago-university']);
    }
    public goToMagoCloudDashboard() {
        this.router.navigate(['magocloud-management/magocloud-dashboard']);
    }
    public goToVerticalSolutionManagement() {
        this.router.navigate(['vertical-solutions/vertical-solutions-management']);
    }

    public goToVerticalSolution() {
        this.router.navigate(['vertical-solutions']);
    }

    public goToVerticalSolutionCrypterSalesModules() {
        this.router.navigate(['vertical-solutions/crypt-sales-modules']);
    }

    public goToVerticalSolutionKeyGeneration() {
        this.router.navigate(['vertical-solutions/key-generation']);
    }

    public goToVerticalSolutionSalesModulesGeneration() {
        this.router.navigate(['vertical-solutions/generate-serial-numbers']);
    }
    public goToVerticalSolutionInsertNewSolution(isnew:boolean) {
        this.router.navigate(['vertical-solutions/insert-new-solution'], {
        queryParams: { isNew: isnew },
    });
    }

    public redirectToSubscriptionManagement(productID: string, subscriptionMode: number, subscriptionKey: string) {
        switch (productID) {
            case IndustryProductID.MW:
                this.magoWebService.tempGraphElement = [];
                this.redirectToMagoWebManagement(subscriptionMode, subscriptionKey);
                break;

            case IndustryProductID.MC:
            default:
                this.redirectToMagoCloudManagementProcess(subscriptionMode, subscriptionKey);
                break;
        }
    }

    private redirectToMagoWebManagement(subscriptionMode: number, subscriptionKey: string) {
        if (subscriptionMode == 1) {
            this.router.navigate(['/magoweb-management/magoweb-management'], {
                queryParams: { subKey: btoa(subscriptionKey), subscriptionNfs: '1' },
            });
        } else {
            this.router.navigate(['/magoweb-management/magoweb-management'], {
                queryParams: { subKey: btoa(subscriptionKey) },
            });
        }
    }

    private redirectToMagoCloudManagementProcess(subscriptionMode: number, subscriptionKey: string) {
        if (subscriptionMode == 1) {
            this.router.navigate(['/magocloud-management/magocloud-management'], {
                queryParams: { subKey: btoa(subscriptionKey), subscriptionNfs: '1' },
            });
        } else {
            this.router.navigate(['/magocloud-management/magocloud-management'], {
                queryParams: { subKey: btoa(subscriptionKey) },
            });
        }
    }

    private redirectToADSPProcess(cartRowID: string, subscriptionKey: string, currentSubscriptionKey: string) {
        if (cartRowID) {
            this.router.navigate(['amazon-dsp-management/amazon-dsp-management'], {
                queryParams: { cartRowID: cartRowID, subKey: btoa(subscriptionKey) },
            });
        } else {
            this.router.navigate(['/amazon-dsp-management/amazon-dsp-management'], {
                queryParams: { subKey: btoa(currentSubscriptionKey) },
            });
        }
    }

    public redirectToSlaveManagement(subscriptionMode: number, subscriptionKey: string) {
        if (subscriptionKey) {
            this.router.navigate(['/store/SlaveManagement'], {
                queryParams: { subKey: btoa(subscriptionKey), parentPage: subscriptionMode },
            });
        }
    }

    setLocalStorageData(name: string, value: string): void {
        if (localStorage.getItem(name)) localStorage.removeItem(name);
        localStorage.setItem(name, value);
    }

    getLocalStorageData<T>(key: string): T {
        if (!localStorage.getItem(key)) return null;
        return JSON.parse(localStorage.getItem(key)) as T;
    }

    deleteLocalStorageData(key: string) {
        localStorage.removeItem(key);
    }
}
